// ABOUTME: UI component for displaying selected SharePoint file information
// ABOUTME: Shows file name, size, modified date with proper styling and icons
/* eslint-disable react/prop-types */

import { Box, Chip, CloudOutlinedIcon, Stack, Typography } from '@ds/coolshop';
import React from 'react';
import { useIntl } from 'react-intl';

import type { ISharePointItem } from '../api/types';

type ISelectedFileDisplayProps = {
    readonly selectedFile: ISharePointItem;
    readonly formatFileSize: (bytes?: number) => string;
    readonly formatDate: (date?: string) => string;
};

export const SelectedFileDisplay: React.FC<ISelectedFileDisplayProps> = React.memo(
    ({ selectedFile, formatFileSize, formatDate }) => {
        const intl = useIntl();

        return (
            <Box p={2} border={1} borderColor="grey.300" borderRadius={1} bgcolor="grey.50" mb={1}>
                <Stack direction="row" alignItems="center" gap={2}>
                    <CloudOutlinedIcon color="primary" />
                    <Box flexGrow={1}>
                        <Typography variant="body2">{selectedFile.name}</Typography>
                        <Stack direction="row" gap={1} alignItems="center" mt={0.5}>
                            {selectedFile.size && (
                                <Chip
                                    label={formatFileSize(selectedFile.size)}
                                    size="small"
                                    variant="outlined"
                                />
                            )}
                            {selectedFile.modified && (
                                <Typography variant="caption" color="text.secondary">
                                    {intl.formatMessage({
                                        id: 'sharepoint.modified',
                                        defaultMessage: 'Modificato:',
                                    })}
                                    {formatDate(selectedFile.modified)}
                                </Typography>
                            )}
                        </Stack>
                    </Box>
                </Stack>
            </Box>
        );
    },
);

SelectedFileDisplay.displayName = 'SelectedFileDisplay';
